// Cálculos globales de KPI de Finanzas — usados por el módulo Finanzas y por el Dashboard.
// Fuente de datos: /api/invoices (mismos items renderizados en la tabla de Finanzas).
// No duplicar cálculos: si aquí cambia, cambia en ambos lugares.

const IVA_MULTIPLIER = 1.19;

const gross = (i) => Math.round(Number(i.net_amount || 0) * IVA_MULTIPLIER);

/**
 * Calcula los tres KPI globales expuestos en el Dashboard y en Finanzas.
 * @param {Array} items - lista completa de facturas de /api/invoices
 * @returns {{ deuda_facturada: {amount:number,count:number}, vencidos: {amount:number,count:number}, por_facturar: {amount:number,count:number} }}
 */
export function computeFinanceKpis(items = []) {
  const facturadas = items.filter((i) => i.status === "facturado"); // Incluye vencidas (siguen siendo status=facturado con is_overdue=true)
  const vencidas = items.filter((i) => i.is_overdue);
  const porFacturar = items.filter((i) => i.status === "por_facturar");

  const sum = (arr) => arr.reduce((a, i) => a + gross(i), 0);

  return {
    deuda_facturada: { amount: sum(facturadas), count: facturadas.length },
    vencidos: { amount: sum(vencidas), count: vencidas.length },
    por_facturar: { amount: sum(porFacturar), count: porFacturar.length },
  };
}
